import React, { useState } from 'react';
import { theme } from '../../theme/theme';
import { Box, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import AlertMessage from '../forms/message';
import {useHistory } from "react-router-dom";
import CustomAvatar from '../avatar';
import companyClient from '../../pages/client/company'

const useStyles = makeStyles({
    root: {
        width: '450px',
    },
    name: {
        ...theme.typography.h4,
        color: theme.palette.text.header,
        display: 'block',
        marginBottom: '0.5rem',
    },
    id: {
        fontSize: '12px',
    },
    marginRight: {
        marginRight: theme.spacing(2),
    },
    button: {
        padding: `${theme.spacing(1)}px 40px`,
        marginRight: theme.spacing(1),
        '&.delete': {
            fontWeight: '600',
        }
    }
})
const defaultMessage = {
    title: null,
    content: null,
    type: null, //green for success, red for error
    open: false,
}

const DeleteCompany = (props) => {
    const company = props.company;
    const classes = useStyles();
    const history = useHistory();
    const [message, setMessage] = useState({
        ...defaultMessage
    });

    const handleClose = () => {
        // console.log("click handleclose")
        setMessage({
            ...defaultMessage
        });
        if (props.page === 'home') {
                    history.push('/companies')
        }else {
            window.location.reload();
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // please add delete company api
        companyClient.delete(company._id,props.token).then((data) => {
            setMessage({title: 'Successful!', content:'Company has been deleted!', type:'green',open:true});
        }).catch((e) => setMessage({title: 'Failed', content:`${e.message} Please try again`, type:'red',open:true}));

    }

    return(

        <div className={classes.root}>
            <Box display="flex" p={3}>
                <CustomAvatar img={company.image} size="medium" className={classes.marginRight} />
                <div>
                    <div className={classes.name}>{company.name}</div>
                    <div className={classes.id}>{company._id}</div>
                </div>
            </Box>
            <form onSubmit={(e) => handleSubmit(e)}>
                <Box display="flex" p={3}>
                    <Button type="submit" className={`${classes.button} delete`} variant="contained" color="secondary">Confirm Delete</Button>
                </Box>
            </form>
            <AlertMessage
                open={message.open}
                close={handleClose}
                title={message.title}
                titleStyle={message.type}
                ariaLabelledby="delete-company-message"
                ariaDescribedby="delete-company-message-content">
                {message.content}
            </AlertMessage>
        </div>
    )
};

export default DeleteCompany;